<div class="row mt-4 mb-3" [formGroup]="cognitoForm">
    <div class="col-5">
      <ng-select class="mt-2"
                 [inputAttrs]="{ 'data-lpignore': 'true' }"
                 [items]="userPools"
                 [closeOnSelect]="true"
                 [searchable]="true"
                 [selectableGroup]="true"
                 [clearable]="false"
                 [selectableGroupAsModel]="true"
                 [clearSearchOnAdd]="true"
                 (change)="initUsers()"
                 bindLabel="name"
                 bindValue="id"
                 placeholder="Select user pool"
                 formControlName="userPoolId">
      </ng-select>
      <!--      <div class="form-floating mb-3">-->
      <!--        <input type="text" id="userPoolId" class="form-control" placeholder="User pool id" formControlName="userPoolId">-->
      <!--        <label for="userPoolId">User pool id</label>-->
      <!--        <small class="text-danger"-->
      <!--               *ngIf="cognitoForm.controls['userPoolId'].hasError('required') && cognitoForm.controls['userPoolId'].dirty">-->
      <!--          User pool id is required-->
      <!--        </small>-->
      <!--      </div>-->
    </div>

    <div class="col-3">
      <button (click)="importUsers()" type="button" class="btn btn-primary mt-2 ms-4" [disabled]="!users || users.length === 0 || isImportButtonDisabled">Import users
      </button>
    </div>
</div>

<ngx-datatable
  class="material"
  style="height: calc(100vh - 180px)"
  [rows]="users"
  [columns]="columns"
  [messages]="{emptyMessage: 'Click to submit to filter', totalMessage: 'Total', selectedMessage: 'Selected'}"
  [columnMode]="ColumnMode.force"
  [headerHeight]="50"
  [footerHeight]="50"
  [scrollbarH]="true"
  [scrollbarV]="true"
  [rowHeight]="50"
  (sort)="onTableSorting()">
</ngx-datatable>

<ng-template #importUserTmpl let-column="column">
  Import user
</ng-template>
<ng-template #usernameTmpl let-column="column">{{ column.name }}</ng-template>
<ng-template #emailTmpl let-column="column">{{ column.name }}</ng-template>



<ng-template #importCellTmpl let-row="row" let-value="value">
  <form [formGroup]="importForm">
    <input type="checkbox" class="form-check-input form-check-input-larger" formControlName="{{row.id}}" *ngIf="bit">
  </form>
</ng-template>
<ng-template #usernameCellTmpl let-row="row" let-value="value">{{value}}</ng-template>
<ng-template #emailCellTmpl let-row="row" let-value="value">{{value}}</ng-template>
